import logSignUpPageViewed from '@alltrails/analytics/events/logSignUpPageViewed';
import TermsOfService from 'components/TermsOfService';
import { useEffect } from 'react';
import { ReactNode } from 'react';
import CustomProvider from 'components/CustomProvider';
import { FormattedMessage } from 'react-intl';
import RegistrationForm from '../RegistrationForm';
import Wrapper from '../Wrapper';

type SignUpFormProps = {
  handleLoginClick?: React.MouseEventHandler<HTMLAnchorElement>;
  handleRegistrationSuccess?(...args: unknown[]): unknown;
  redirectTo?: string;
  referralLink?: string;
};

function SignUpForm({ handleRegistrationSuccess, redirectTo, handleLoginClick, referralLink }: SignUpFormProps) {
  useEffect(() => {
    logSignUpPageViewed();
  }, []);

  return (
    <CustomProvider>
      <Wrapper foot={<TermsOfService />} text={{ headText: <FormattedMessage defaultMessage="Create your free account" /> }}>
        <RegistrationForm
          handleLoginClick={handleLoginClick}
          handleRegistrationSuccess={handleRegistrationSuccess}
          redirectTo={redirectTo}
          referralLink={referralLink}
          userEmailSubscribed
        />
      </Wrapper>
    </CustomProvider>
  );
}

SignUpForm.defaultProps = {
  handleRegistrationSuccess: () => {},
  redirectTo: null,
  referralLink: null
};

export default SignUpForm;
